module.exports = __webpack_public_path__ + "img/fig3.4b1c9cab.png";